import mixpanel from 'mixpanel-browser';

const MIXPANEL_TOKEN = process.env.REACT_APP_MIXPANEL_TOKEN;
const APP_NAME = process.env.REACT_APP_MIXPANEL_APP_NAME || 'MeisterGruen';

export const mixpanelInit = () => {
    if (MIXPANEL_TOKEN) {
        mixpanel.init(MIXPANEL_TOKEN, {
            api_host: 'https://api-eu.mixpanel.com', // EU projesi için zorunlu
            track_pageview: true,
            persistence: 'localStorage',
            ignore_dnt: true,
        });
    }
};

export const trackEvent = (eventName, props) => {
    if (MIXPANEL_TOKEN) {
        mixpanel.track(eventName, {
            ...props,
            appName: APP_NAME,
        });
    }
};

export const trackPageView = (pageName) => {
    if (MIXPANEL_TOKEN) {
        mixpanel.track('Page View', {
            page: pageName,
            appName: APP_NAME,
        });
    }
};
